import React, { useEffect, useState } from 'react';
import { reduxForm } from 'redux-form';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  TypeOperationRadioInput,
  TitleJob,
  Description,
  FormActions,
  SectionOpportunity,
  InputTitle
} from '@app/src/views/StepOne/form';
import { isClientEnv } from '@app/src/utils/validations';
import { setPrintGeneral, GeneralModel, cleanPrintGeneral } from '@app/src/views/StepTwo/channelPublication';
import { clearJobSelected } from '@app/src/views/StepOne/form';
import { CATEGORIES, CATEGORY, CATEGORY_ALIAS } from '@app/src/config/categories';
import { Title } from '@app/src/common/Title';
import { FormWrapper } from './styled';

const isClient = isClientEnv();

interface Props {
  handleSubmit?: Function;
}

const Form: React.FC<Props> = ({ handleSubmit }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentOperation = useSelector(state => state.form.stepOne.values.operation);
  const currentOperationName = useSelector(state => state.form.stepOne.values.operationName);
  const currentTitle = useSelector(state => state.form.stepOne.values.title);
  const currentDescription = useSelector(state => state.form.stepOne.values.description);
  const currentSectionName = useSelector(state => state.form.stepOne.values.sectionName);
  const print = isClient && JSON.parse(sessionStorage.getItem('print'));
  const categoryId = useSelector(state => state.print.general.category);
  const [categoryConfig, setCategoryConfig] = useState(null);

  useEffect(() => {
    if (categoryId) {
      setCategoryConfig(CATEGORIES[CATEGORY[categoryId]]);
    }
  }, [categoryId]);

  useEffect(() => {
    if (currentDescription && isClient) {
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      }
    }
  }, [currentDescription]);

  const handleBeforeUnload = (e) => {
    if (isClient) {
      sessionStorage.setItem('print', JSON.stringify({ general: { category: categoryId } }));
      e.returnValue = '¿Desea descartar cambios?';
    }
  };

  const handleClickSubmit = (data: GeneralModel) => {
    const updatePrint = createPrintStorage(data);
    isClient && sessionStorage.setItem('print', JSON.stringify(updatePrint));
    dispatch(setPrintGeneral(updatePrint));
    pushDatalayer(
      categoryConfig.name,
      currentOperationName,
      currentSectionName
    );
    history.push(`${categoryConfig.link}-2`);
  };

  const quitLastSpace = (text) => {
    let arrText = text.split(' ');
    if (arrText[arrText.length - 1].length === 0) {
      arrText.pop();
    }
    return arrText.join(' ');
  };

  const createPrintStorage = (data) => {
    const objPrint = {};

    if (print && print.hasOwnProperty('printsByChannel')) {
      objPrint['printsByChannel'] = print.printsByChannel;
    } else {
      objPrint['printsByChannel'] = {};
    }
    data.description = quitLastSpace(data.description);
    objPrint['general'] = data;
    return objPrint;
  };

  const handleClickReset = (e) => {
    e.preventDefault();
    if (currentDescription) {
      const isDiscardChanges = confirm('¿desea descartar cambios?');
      if (!isDiscardChanges) {
        return;
      }
    }
    history.push('/#inicio');
    sessionStorage.removeItem('print');
    dispatch(cleanPrintGeneral());
    dispatch(clearJobSelected());
  };

  const pushDatalayer = (categoryName: string, operationName: string, section?: string) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'Posting',
        'eventAction': `Paso1 - ${categoryName}`,
        'eventLabel': `${operationName}${section ? `|${section}`: ''}`,
        'eventValue': 1
      })
    }
  };

  return (
    <FormWrapper>
      <Title>Datos del aviso</Title>
      <TypeOperationRadioInput colorTheme={categoryConfig && categoryConfig.color} />
      {
        currentOperation && categoryConfig &&
        categoryConfig.alias === CATEGORY_ALIAS.EMPLEO &&
        <TitleJob operationId={currentOperation} />
      }
      {
        currentOperation && categoryConfig &&
        categoryConfig.alias === CATEGORY_ALIAS.OPORTUNIDAD &&
        <SectionOpportunity operationId={currentOperation} />
      }
      {
        currentOperation && categoryConfig &&
        categoryConfig.alias === CATEGORY_ALIAS.EDUCACION &&
        <InputTitle placeholder="Ej. DOCENTE UNIV" />
      }
      {
        currentOperation && currentTitle &&
        <Description
          includeWords={12}
          extraWords={8}
        />
      }
      <FormActions
        categoryConfig={categoryConfig}
        showButtonNext={currentOperation && currentTitle}
        handleButtonNext={handleSubmit(handleClickSubmit)}
        handleButtonPrev={handleClickReset}
      />
    </FormWrapper>
  )
};

const FormJobHoc = reduxForm({
  form: 'stepOne',
  initialValues: {
    category: null,
    operation: null,
    operationName: '',
    title: '',
    description: '',
    employment: null,
    employmentName: '',
    section: null,
    extraWords: null,
  }
})(Form);

export { FormJobHoc as FormJob };
